/*
 * PrivacySettings Messages
 *
 * This contains all the text for the PrivacySettings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    emptyMessage: {
        id: 'app.containers.dataGrid.emptyMessage',
        defaultMessage: 'No data found!'
    },
    loadingMessage: {
        id: 'app.containers.dataGrid.loadingMessage',
        defaultMessage: 'Loading...'
    },
    copyLabel: {
        id: 'app.containers.masterCourses.copyLabel',
        defaultMessage: 'Copy'
    },
    title: {
        id: 'app.containers.masterCourses.title',
        defaultMessage: 'Internal Course Manager'
    },
    subtitle: {
        id: 'app.containers.masterCourses.subtitle',
        defaultMessage: 'Master Courses'
    },
    countryLabel: {
        id: 'app.containers.masterCourses.countryLabel',
        defaultMessage: 'Country'
    },
    yearLabel: {
        id: 'app.containers.masterCourses.yearLabel',
        defaultMessage: 'Year'
    },
    curriculumLabel: {
        id: 'app.containers.masterCourses.curriculumLabel',
        defaultMessage: 'Curriculum'
    },
    stateLabel: {
        id: 'app.containers.masterCourses.stateLabel',
        defaultMessage: 'State/Province'
    },
    actionLabel: {
        id: 'app.containers.masterCourses.actionLabel',
        defaultMessage: 'Action'
    },
    dateModifiedLabel: {
        id: 'app.containers.masterCourses.dateModifiedLabel',
        defaultMessage: 'Date modified'
    },
    versionLabel: {
        id: 'app.containers.masterCourses.versionLabel',
        defaultMessage: 'Version'
    },
    subject: {
        id: 'app.containers.masterCourses.subject',
        defaultMessage: 'Subject'
    }
});



// WEBPACK FOOTER //
// ./app/containers/master-courses/messages.js